<template>
    <div class="expats--header--wrapper">
        <div class="gradient-box">
        </div>
        <div class="header--slider-wrapper">
            <div class="slider-background">
                <div class="header--slider">
                    <img src="/static/img/expat_page/slider-photos/loading_slider_new.jpg" alt="" class="responsive--img">
                </div>
            </div>
        </div>
        <div class="container-grid">
            <div class="header--info">
                <div class="header--info__copy">
                    <h1 class="heading--xl text-left heading">LOADING<br/> NEW TERRAIN…</h1>
                    <p class="paragraph text-left">
                        Our games may transport you to completely new places, but so does a Bohemian career in games
                        development. Over the years, we have welcomed professionals from all over the world, and our
                        diverse studios are currently home to over 20 different nationalities. We know moving to another
                        country can be a daunting (and exciting!) adventure, so, allow us to introduce you to your
                        potential new home...
                    </p>
                </div>
                <div class="scroll-down-button">
                    <button class="button" v-scroll-to="{ element: '#welcome-to-czech', duration: 1000 }"><i
                            class="icons8-arrow-up-slider--01"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import BasicButton from "../BasicButton";
  import Label from "../common/Label";

  export default {
    components: {
      Label,
      BasicButton
    },
    name: "MainHeader"
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/main";
    @import "../../assets/scss/globals";

    $bg-color: #ffffff;
    $dot-color: rgba(77, 77, 77, 0.1);
    $header-overlap: 1700px;

    // Dimensions
    $dot-size: 2px;
    $dot-space: 12px;

    .responsive--img {
        width: 100%;
        max-width: 100%;
        display: block;
    }

    .scroll-down-button {
        @media(max-width: 1500px) {
            display: none;
        }
        position: absolute;
        left: 0;
        bottom: -50%;

        button {
            transform: rotateZ(180deg);

            i {
                font-size: 28px;
            }
        }
    }


    .expats--header--wrapper {
        position: relative;
        min-height: 991px;
        margin: auto;
        max-width: 1920px;
        padding-top: 120px;
        display: flex;
        justify-content: center;
        background: radial-gradient($dot-color 20%, rgba(0, 0, 0, 0) 16%), radial-gradient($dot-color 15%, rgba(0, 0, 0, 0) 16%), $bg-color;
        background-position: 16px 16px, 16px 16px;
        -webkit-background-origin: padding-box;
        background-origin: padding-box;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        -webkit-background-size: 12px 12px;
        background-size: 12px 12px;

        @media (max-width: 1400px) {
            padding-top: 90px;
        }
        @media (max-width: $tablet) {
            min-height: 100%;

        }
        @media (max-width: 768px) {
            flex-wrap: wrap;
            justify-content: flex-end;
            background-size: 100% 100%;
            background: linear-gradient(180deg, rgba(0, 186, 136, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);

        }

        @media (max-width: 425px) {
            background: url('/static/img/expat_page/mobile/expats_mobile_header.png');
            background-size: 100% 100%;
        }

        @media (max-width: 320px) {
            background-repeat: no-repeat;
        }
    }

    .header--info {
        width: 50%;
        position: relative;
        font-size: 90px;
        word-wrap: break-word;
        @media (max-width: 768px) {
            width: 100%;
        }

        @media (max-width: 320px) {
            font-size: 19px;
        }
    }

    .header--slider-wrapper {
        top: 0;
        position: absolute;
        z-index: 1;
        right: 0;
        width: 59%;
        height: 100%;
        background: #fff;

        .slider-background {
            position: absolute;
            z-index: 1;
            padding-top: 120px;
            right: 0;
            top: 0;
            height: 100%;
            max-height: 919px;
            background: url("/static/img/expat_page/meshbackground_header.png");
            background-size: 100% 120%;

            @media (max-width: 1400px) {
                padding-top: 90px;
            }
            @media (max-width: 768px) {
                padding-top: 0px;
                position: relative;
            }
        }

        @media (max-width: 1700px) {
            width: 70%;
        }
        @media (max-width: 1450px) {
            width: 85%;
        }
        @media (max-width: 1200px) {
            width: 95%;
        }
        @media (max-width: 768px) {
            position: relative;
            width: 86%;
        }

        @media (max-width: $compact) {
            top: -30px;
        }

    }

    .header--slider {
        @media (max-width: 1024px) {
            width: 766px;
            height: 461px;
        }

        @media (max-width: 769px) {
            z-index: 2;
            right: 0;
            max-width: 100%;
            height: 100%;

        }
    }

    .heading {
        color: $text-strong;

        @media (max-width: $tablet) {
            font-size: 50px;
        }
        @media (max-width: 768px) {
            margin-top: -124px;
            font-size: 38px;
        }
        @media (max-width: $compact) {
            margin-top: -48px;
        }
    }

    .paragraph {
        padding-top: 2em;
        @media (max-width: $tablet) {
            padding-top: 1em;
            font-size: 14px;
        }
    }

    .gradient-box {
        width: 50%;
        height: 600px;
        background-image: linear-gradient(180deg, rgba(0, 186, 136, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        opacity: 0.9;
        z-index: 2;
        position: absolute;
        top: 120px;
        left: 0;
        @media (max-width: 1400px) {
            top: 90px;
        }
        @media (max-width: 1024px) {
            height: 100%;

        }
        @media (max-width: 768px) {
            display: none;
        }

        @media (max-width: $compact--sm) {
            height: 80vh;
            top: -1.9em;
        }

        @media (max-width: 375px) {
            height: 80vh;
            top: -1.68em;
        }

        @media (max-width: 320px) {
            height: 80vh;
            top: -1.43em;
        }
    }

    .header--info__copy {
        position: relative;
        z-index: 3;
        max-width: 100%;
        padding-right: 50px;
        margin-top: 51px;


        @media (max-width: 1440px) {
            max-width: 100%;
            left: 0;
            padding: 30px;

        }

        @media (max-width: $tablet) {
            max-width: 100%;
            left: 0;
            padding: 30px;
            margin-top: 0;
        }
    }

    .header--container {
        @media (max-width: $tablet) {
            margin-top: 10%;
        }

        @media (max-width: $compact) {
            padding: 27px;
            margin-top: 0%;
        }
    }

    .container-grid {
        max-width: 1200px;
        @media (max-width: $tablet) {
            margin-top: 0 !important;
            margin-bottom: 0 !important;

        }

    }
</style>



// WEBPACK FOOTER //
// src/components/expatsPageComponents/ExpatsHeader.vue